// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { AffiliatePayoutOperationsService } from '../generated/api/affiliatePayoutOperations.service';

@Injectable({ providedIn: 'root' })
export class AffiliatePayoutOperationsClientService {
  constructor(private readonly client: AffiliatePayoutOperationsService) {}
  // <generated-client-wrappers:methods>
  accelerate(
    batchId: string,
    request: WrapperApi.PayoutBatchAccelerationRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PayoutBatchResponse> {
    if (!this.client)
      throw new Error('AffiliatePayoutOperationsService is not available');
    return this.client.affiliatePayoutOperationsAccelerate(
      batchId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  get(
    page?: number,
    pageSize?: number,
    countryCode?: string,
    currencyCode?: string,
    statusKey?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PayoutBatchPageResponse> {
    if (!this.client)
      throw new Error('AffiliatePayoutOperationsService is not available');
    return this.client.affiliatePayoutOperationsGet(
      page,
      pageSize,
      countryCode,
      currencyCode,
      statusKey,
      'body',
      reportProgress,
      options,
    );
  }

  getDetail(
    batchId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PayoutBatchDetailResponse> {
    if (!this.client)
      throw new Error('AffiliatePayoutOperationsService is not available');
    return this.client.affiliatePayoutOperationsGetDetail(
      batchId,
      'body',
      reportProgress,
      options,
    );
  }

  hold(
    batchId: string,
    request: WrapperApi.PayoutBatchAdministrativeCommandRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PayoutBatchResponse> {
    if (!this.client)
      throw new Error('AffiliatePayoutOperationsService is not available');
    return this.client.affiliatePayoutOperationsHold(
      batchId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  release(
    batchId: string,
    request: WrapperApi.PayoutBatchAdministrativeCommandRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PayoutBatchResponse> {
    if (!this.client)
      throw new Error('AffiliatePayoutOperationsService is not available');
    return this.client.affiliatePayoutOperationsRelease(
      batchId,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
